import { AbstractControl } from '@angular/forms';
import { isNullish } from './helpers.util';

export function getError(
  control: AbstractControl,
  errorsDictionary: object,
): string {
  const errorNames = Object.keys(errorsDictionary);
  const activeErrorName = errorNames.filter(
    (k) => control && control.errors && !!control.errors[k],
  )[0];
  const errorLabel = errorsDictionary[activeErrorName];
  const dynamicText = typeof errorLabel === 'function';
  const dynamicTextArg = control.errors?.[activeErrorName];
  const hasDynamicTextArg = !isNullish(dynamicTextArg);

  return (
    (dynamicText && hasDynamicTextArg ? errorLabel(dynamicTextArg) : errorLabel) ||
    (activeErrorName &&
      control &&
      control.errors &&
      control.errors[activeErrorName].value) ||
    ''
  );
}

export function getErrorWithArgs(
  control: AbstractControl,
  errorsDictionary: object,
  args: Record<string, string | number | boolean>,
): string {
  const keys = Object.keys(errorsDictionary);
  const activeError = keys.filter(
    (k) => control && control.errors && !!control.errors[k],
  )[0];
  return (
    // Checking if passed value is not nullish
    // because *false* should be treated correctly
    ((args[activeError] !== null && args[activeError] !== undefined)
      ? errorsDictionary[activeError](args[activeError])
      : errorsDictionary[activeError]) ||
    (activeError &&
      control &&
      control.errors &&
      control.errors[activeError].value) ||
    'Unspecified error'
  );
}
